(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foooter-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-v2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  const MobileNavAccordion = new Accordion('.header-wrapper--old .menu-drawer__navigation', {
    openOnInit: [0],
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"]) return;
  try {
    
  window.addEventListener('load', function() {
    const customersSlider = new Swiper('.press__customers__slider', {
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT_SELECTOR = '[data-sticky-atc]';
    var initialised = [];

    function parseVariants(root) {
      try {
        return JSON.parse(root.getAttribute('data-variants') || '[]');
      } catch (error) {
        return [];
      }
    }

    function isVisible(el) {
      if (!el) return false;
      if (el.hasAttribute('hidden')) return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }
      return el.getClientRects().length > 0;
    }

    function queryBest(selector) {
      if (!selector) return null;
      var nodes;
      try {
        nodes = document.querySelectorAll(selector);
      } catch (error) {
        return null;
      }
      if (!nodes || !nodes.length) return null;

      var buyBox = null;
      var visible = null;
      var first = nodes[0];

      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.matches && el.matches('.buy-box__primary-cta, [data-buy-box-submit]')) {
          if (isVisible(el)) return el;
          if (!buyBox) buyBox = el;
        }
        if (!visible && isVisible(el)) visible = el;
      }

      return buyBox || visible || first;
    }

    function getAlpinePdpData() {
      if (!window.Alpine || typeof Alpine.$data !== 'function') return null;
      var roots = document.querySelectorAll('[x-data]');
      for (var i = 0; i < roots.length; i++) {
        try {
          var data = Alpine.$data(roots[i]);
          if (data && typeof data.addToCart === 'function' && typeof data.quantity !== 'undefined') {
            return data;
          }
        } catch (error) {
          // Keep scanning.
        }
      }
      return null;
    }

    function syncQtySelectButtons(quantity) {
      var buttons = document.querySelectorAll('.product-redesign__qty-btn-select');
      if (!buttons.length) return;

      var active = document.querySelector('.product-redesign__qty-btn-select-active');
      for (var i = 0; i < buttons.length; i++) {
        var candidate = buttons[i];
        var label = (candidate.textContent || '').trim();
        if (String(quantity) === label && isVisible(candidate)) {
          if (candidate !== active) candidate.click();
          return;
        }
      }
    }

    function init(root, options) {
      options = options || {};
      if (!root || initialised.indexOf(root) !== -1) return;

      var atcSelector = root.getAttribute('data-atc-selector') || '';
      var triggerSelector = root.getAttribute('data-trigger-selector') || '';
      var soldOutLabel = root.getAttribute('data-sold-out-label') || '';
      var showQuantity = root.getAttribute('data-show-quantity') === 'true';
      var variants = parseVariants(root);

      var stickyButton = root.querySelector('[data-sticky-atc-button]');
      var stickyLabel = root.querySelector('[data-sticky-atc-button-label]');
      var priceCurrent = root.querySelector('[data-sticky-atc-current]');
      var qtyValueEl = root.querySelector('[data-sticky-atc-qty-value]');
      var qtyDecBtn = root.querySelector('[data-sticky-atc-qty-dec]');
      var qtyIncBtn = root.querySelector('[data-sticky-atc-qty-inc]');
      var defaultLabel = stickyLabel ? stickyLabel.textContent.trim() : '';

      var realButton = queryBest(atcSelector);
      var trigger = queryBest(triggerSelector) || realButton;

      // Without the theme's own Add to Cart button there is nothing to proxy to.
      // Retry briefly for Alpine redesign PDPs before removing.
      if (!realButton || !trigger || !stickyButton) {
        if (options.allowRemove) {
          root.parentNode && root.parentNode.removeChild(root);
        }
        return;
      }

      initialised.push(root);
      root.setAttribute('data-sticky-atc-ready', 'true');

      var form = realButton.closest('form');
      var variantInput = form ? form.querySelector('[name="id"]') : null;

      function show() {
        root.classList.add('is-visible');
        root.setAttribute('aria-hidden', 'false');
      }

      function hide() {
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
      }

      function currentVariantId() {
        var alpine = getAlpinePdpData();
        if (alpine && alpine.selectedVariantId) {
          return parseInt(alpine.selectedVariantId, 10);
        }
        if (variantInput && variantInput.value) {
          return parseInt(variantInput.value, 10);
        }
        var hiddenId = document.querySelector('.pdp-info__container [name="id"], [data-buy-box] [name="id"]');
        if (hiddenId && hiddenId.value) return parseInt(hiddenId.value, 10);
        return NaN;
      }

      function findVariant() {
        var id = currentVariantId();
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === id) return variants[i];
        }
        return variants[0] || null;
      }

      var lastVariantId = null;

      function visibleText(el) {
        if (!el || !isVisible(el)) return '';
        return (el.textContent || '').trim();
      }

      function applyStickyPrice(currentText) {
        if (!priceCurrent || !currentText) return false;
        priceCurrent.textContent = currentText;
        return true;
      }

      // Prefer the live redesign / buy-box current price so sticky matches
      // subscription, OTP, promo params, and qty-driven discounts exactly.
      // Compare-at / struck prices are intentionally not shown on sticky.
      function syncPriceFromRedesign() {
        if (!priceCurrent) return false;

        var buyBoxCurrent = document.querySelector('[data-buy-box-price-current]');
        if (buyBoxCurrent && isVisible(buyBoxCurrent)) {
          return applyStickyPrice(visibleText(buyBoxCurrent));
        }

        var otp2Active = document.querySelector('.otp2-option--active');
        if (otp2Active && isVisible(otp2Active)) {
          var otp2Price = otp2Active.querySelector('.otp2-option__price');
          var otp2Current = visibleText(otp2Price);
          if (otp2Current) return applyStickyPrice(otp2Current);
        }

        var heroWrapper = document.querySelector('.pdp-info__price-wrapper');
        if (heroWrapper && isVisible(heroWrapper)) {
          var heroCurrent = heroWrapper.querySelector('.current-price');
          var heroCurrentText = visibleText(heroCurrent);
          if (heroCurrentText) return applyStickyPrice(heroCurrentText);
        }

        // Fallback: first visible redesign current-price (skip hidden ATC inline prices).
        var currentNodes = document.querySelectorAll(
          '.pdp-info__container .current-price, .product-redesign .current-price'
        );
        for (var i = 0; i < currentNodes.length; i++) {
          var node = currentNodes[i];
          if (node.closest && node.closest('.product-redesign__atc-prices')) continue;
          var text = visibleText(node);
          if (!text) continue;
          return applyStickyPrice(text);
        }

        return false;
      }

      function syncVariant() {
        var variant = findVariant();
        if (!variant) return;
        if (variant.id !== lastVariantId) {
          lastVariantId = variant.id;
        }

        if (!syncPriceFromRedesign()) {
          if (priceCurrent) priceCurrent.textContent = variant.price;
        }

        var unavailable = variant.available === false;
        stickyButton.disabled = unavailable;
        if (stickyLabel) {
          stickyLabel.textContent = unavailable ? soldOutLabel : defaultLabel;
        }
      }

      function readThemeQuantity() {
        var buyBoxQty = document.querySelector('[data-buy-box-qty-value]');
        if (buyBoxQty && isVisible(buyBoxQty.closest('[data-buy-box-qty]') || buyBoxQty)) {
          return Math.max(1, parseInt(buyBoxQty.value, 10) || 1);
        }

        var alpine = getAlpinePdpData();
        if (alpine && typeof alpine.quantity !== 'undefined') {
          return Math.max(1, parseInt(alpine.quantity, 10) || 1);
        }

        var qtyInput = document.querySelector('.product-redesign__quantity-container input');
        if (qtyInput) {
          return Math.max(1, parseInt(qtyInput.value, 10) || 1);
        }

        return 1;
      }

      function renderStickyQuantity() {
        if (!qtyValueEl) return;
        var qty = readThemeQuantity();
        qtyValueEl.textContent = String(qty);
        if (qtyDecBtn) qtyDecBtn.disabled = qty <= 1;
      }

      function changeQuantity(delta) {
        var buyBoxDec = document.querySelector('[data-buy-box-qty-dec]');
        var buyBoxInc = document.querySelector('[data-buy-box-qty-inc]');
        if (buyBoxDec && buyBoxInc && document.querySelector('[data-buy-box-qty-value]')) {
          if (delta < 0) buyBoxDec.click();
          else buyBoxInc.click();
          renderStickyQuantity();
          return;
        }

        var themeDec = document.querySelector('.product-redesign__dec-btn');
        var themeInc = document.querySelector('.product-redesign__inc-btn');
        if (themeDec && themeInc) {
          if (delta < 0) themeDec.click();
          else themeInc.click();
          renderStickyQuantity();
          return;
        }

        var alpine = getAlpinePdpData();
        if (alpine) {
          if (delta < 0 && typeof alpine.dec === 'function') alpine.dec();
          else if (delta > 0 && typeof alpine.inc === 'function') alpine.inc();
          else {
            alpine.quantity = Math.max(1, (parseInt(alpine.quantity, 10) || 1) + delta);
          }
          syncQtySelectButtons(parseInt(alpine.quantity, 10) || 1);
          renderStickyQuantity();
          return;
        }
      }

      // Show the bar once the main Add to Cart control has scrolled out of view above.
      function onScroll() {
  var triggerBottom = trigger.getBoundingClientRect().bottom;

  if (triggerBottom < -4000) {
    show();
  } else {
    hide();
  }
}

window.addEventListener('scroll', onScroll, { passive: true });
onScroll();

      function syncBrandFromAtc() {
        var target = queryBest(atcSelector);
        if (!target || !stickyButton) return;

        var style = window.getComputedStyle(target);
        var bg = style.backgroundColor;
        if (
          bg &&
          bg !== 'transparent' &&
          bg !== 'rgba(0, 0, 0, 0)' &&
          bg !== 'rgba(0,0,0,0)'
        ) {
          stickyButton.style.backgroundColor = bg;
          root.style.setProperty('--sticky-atc-button-background', bg);
          root.style.setProperty('--sticky-atc-price', bg);
          if (priceCurrent) priceCurrent.style.color = bg;
        }

        if (style.color) {
          stickyButton.style.color = style.color;
          root.style.setProperty('--sticky-atc-button-text', style.color);
        }

        // Match redesign ATC chrome even if the live button border was overridden.
        stickyButton.style.border = '1px solid #949494';
        if (style.borderRadius) {
          stickyButton.style.borderRadius = style.borderRadius;
        }
      }

      stickyButton.addEventListener('click', function (event) {
        event.preventDefault();
        var target = queryBest(atcSelector);
        if (!target || target.disabled) return;
        target.click();
      });

      if (showQuantity && qtyDecBtn && qtyIncBtn) {
        qtyDecBtn.addEventListener('click', function (event) {
          event.preventDefault();
          changeQuantity(-1);
        });
        qtyIncBtn.addEventListener('click', function (event) {
          event.preventDefault();
          changeQuantity(1);
        });
      }

      if (form) {
        form.addEventListener('change', function () {
          syncVariant();
          syncBrandFromAtc();
        });
      }

      if (variantInput && 'MutationObserver' in window) {
        new MutationObserver(function () {
          syncVariant();
          syncBrandFromAtc();
        }).observe(variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }

      document.addEventListener('variant:change', function () {
        syncVariant();
        syncBrandFromAtc();
      });
      document.addEventListener('variantChange', function () {
        syncVariant();
        syncBrandFromAtc();
      });
      document.addEventListener('product:variant-changed', function () {
        syncVariant();
        syncBrandFromAtc();
      });

      // Fallback for themes that set the variant / qty / ATC style silently via JavaScript (Alpine).
      setInterval(function () {
        syncVariant();
        renderStickyQuantity();
        syncBrandFromAtc();
      }, 500);

      syncVariant();
      renderStickyQuantity();
      syncBrandFromAtc();
    }

    function initAll(allowRemove) {
      var roots = document.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < roots.length; i++) {
        init(roots[i], { allowRemove: !!allowRemove });
      }
    }

    function boot() {
      initAll(false);
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        var pending = document.querySelectorAll(ROOT_SELECTOR + ':not([data-sticky-atc-ready])');
        var finalAttempt = attempts >= 10;
        for (var i = 0; i < pending.length; i++) {
          init(pending[i], { allowRemove: finalAttempt });
        }
        if (finalAttempt) clearInterval(timer);
      }, 300);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function () {
      initAll(true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
